import React, { useState, useEffect } from "react";
import { Table } from "antd";
import ManagementService from "../../services/manageService";
import { useTranslation } from "react-i18next";
import "./style.scss";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { getAllPermissionFormatArray } from "constants/permission";
import { ROLE_ID_DIRECTOR } from "constants/permission";

const Explaintation = () => {
  const { t: translation } = useTranslation();
  const [dataFilter, setDataFilter] = useState({});
  const [data, setData] = useState([]);

  const fetchData = (param) => {
    ManagementService.getListRole(param).then((result) => {
      if (result) {
        setData(result.data);
      }
    });
  };

  useEffect(() => {
    fetchData(dataFilter);
  }, []);

  const allPermission = getAllPermissionFormatArray();
  const arrayRenderPermission = allPermission.map(item => {
    return {
      title: (
        <div style={{ color: "#086FD7" }}>
          {item.label}
        </div>
      ),
      width: 50,
      align: "center",
      render: (_, record) => {
        const { permissions } = record;
        const index = permissions.search(item.value);
        return (
          <>
            {index === -1 && record?.appUserRoleId !== ROLE_ID_DIRECTOR ? (
              <div className="close"><CloseOutlined style={{ fontSize: '22px', color: 'red', marginTop:'8px' }}/></div>
              ) : (
              <div className="check"><CheckOutlined style={{ fontSize: '22px', color: 'green', marginTop:'8px' }}/></div>
            )}
          </>
        );
      },
    }
  })
  const columns = [
    {
      title: "",
      key: "appUserRoleName",
      dataIndex: "appUserRoleName",
      width: 50,
      align: "center",
      render: (_, record) => {
        const { appUserRoleName } = record;
        return <div style={{ color: "#5F00FA", fontWeight : '700' }}>{appUserRoleName}</div>;
      },
    },
    ...arrayRenderPermission
  ];
  return (
    <div className="container">
      <Table
        dataSource={data}
        columns={columns}
        scroll={{ x: 1230 }}
        pagination={false}
        bordered={true}
      />
    </div>
  );
};

export default Explaintation;
